import {Component, HostListener, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {MarketAccounting} from '../../../entities/market-accounting.model';
import {ApiService} from '../../../shared/services/api.service';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {IMyDateRangeModel, IMyDrpOptions} from 'mydaterangepicker';
import {JhiLanguageService} from 'ng-jhipster';
import {Router} from '@angular/router';
import {MarketdateStatusEnum} from '../../../entities/marketdate.model';
import {ColumnMode, DatatableComponent} from '@swimlane/ngx-datatable';
import {RoutingDataService} from '../../../shared/services/routing-data.service';
import {TimerObservable} from 'rxjs/observable/TimerObservable';
import {LocalStorageService} from 'ng2-webstorage';
import {DatePipe} from '@angular/common';
import {EventManagerService} from '../../../shared/services/event-manager.service';
import {MarketOverviewViewEntry} from '../../../entities/market-overview-view-entry.model';
import {Principal} from '../../../shared';
import {User} from '../../../entities/user.model';

@Component({
  selector: 'app-markets',
  templateUrl: './markets.component.html',
  styles: []
})
export class MarketsComponent implements OnInit, OnDestroy {

  private alive: boolean;
  public autoUpdateActive: boolean;
  private interval: number;
  public lastUpdated: Date;
  public initialUpdateTime: number;

  @ViewChild('dateCellTpl') dateCellTpl: TemplateRef<any>;
  @ViewChild('dateRangeToLargeModal') private dateRangeToLargeModal;
  @ViewChild('refreshModal') private refreshModal;
  refreshModalRef: NgbModalRef = null;
  @ViewChild('errorLoadingMarketsModal') private errorLoadingMarketsModal;
  loadingError: any;
  @ViewChild('marketsTable') marketsTable: DatatableComponent;

  marketList: string;

  loadingIndicator = true;

  rows = [];
  limit = 10;
  marketOverviewEntries: MarketOverviewViewEntry[];
  selectedMarketAccounting: any = null;
  sorting = [{prop: 'updatedAt', dir: 'desc'}];
  sortType = 'multi';
  offset = 0;

  dateRangePickerOptions: IMyDrpOptions = {
    dayLabels: {su: 'So', mo: 'Mon', tu: 'Di', we: 'Mi', th: 'Do', fr: 'Fr', sa: 'Sa'},
    monthLabels: { 1: 'Jan', 2: 'Feb', 3: 'Mrz', 4: 'Apr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Aug', 9: 'Sep', 10: 'Okt',
      11: 'Nov', 12: 'Dez' },
    dateFormat: 'dd.mm.yyyy',
    yearSelector: false,
    monthSelector: false,
    selectBeginDateTxt: 'Startdatum auswählen',
    selectEndDateTxt: 'Enddatum auswählen',
    showClearBtn: true,
    showApplyBtn: true,
    openSelectorOnInputClick: true,
    height: '26px',
    width: '239px'
  };

  dateRangeModel: any = {
    beginDate: {
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      day: new Date().getDate()
    },
    endDate: {
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      day: new Date().getDate()
    }
  };

  maxDateRangeDays: number;

  newEndDate: any;
  dateRangeChanged = false;
  dateRangeIsValid = true;

  modalRef: any = null;
  dateRangeToLargeModalReg: NgbModalRef = null;

  marketdateStatus: {value: string, label: string, selected: boolean, visible: boolean} [];

  daterangeFilter: {
    label: string,
    options: {
      value: string,
      label: string,
      selected: boolean
    }[],
    selected: {
      value: string,
      label: string,
      selected: boolean
    }
  };

  statusFilter: {
    filterProperty: string,
    label: string,
    options: {
      value: string,
      label: string,
    }[],
    selected: {
      value: string,
      label: string,
    }
  };

  weekdayFilter: {
    filterProperty: string,
    label: string,
    options: {
      value: string,
      label: string,
    }[],
    selected: {
      value: string,
      label: string,
    }
  };

  branchFilter: {
    filterProperty: string,
    label: string,
    options: {
      value: string,
      label: string,
    }[],
    selected: {
      value: string,
      label: string,
    }
  };

  searchInputMarketTitle = '';
  searchInputMarketNumber = '';
  searchInputMarketMaster = '';
  searchInputClosingMarketMaster = '';
  tempRows = [];
  allRows = [];

  private user: User;


  constructor(
    private jhiLanguageService: JhiLanguageService,
    private apiService: ApiService,
    private modalService: NgbModal,
    public router: Router,
    private routingData: RoutingDataService,
    private localStorage: LocalStorageService,
    private datePipe: DatePipe,
    private eventManager: EventManagerService,
    private principal: Principal
  ) {

    this.principal.identity().then((user: User) => {
      this.user = user;
    });

    this.autoUpdateActive = (this.localStorage.retrieve('autoUpdate') !== null)
      ? this.localStorage.retrieve('autoUpdate') : true;

    // set autoUpdateActive to true, as Mr. Stahl considered the setting in the frontend to be insignificant.
    this.autoUpdateActive = true;
    this.autoUpdateChange();

    this.alive = true;
    this.interval = 300000;
    this.lastUpdated = (this.localStorage.retrieve('lastUpdated')) ? new Date(this.localStorage.retrieve('lastUpdated')) : new Date();
    if (this.localStorage.retrieve('lastUpdated') && (this.interval - (new Date().getTime() - this.lastUpdated.getTime())) > 0) {
      this.initialUpdateTime = this.interval - (new Date().getTime() - this.lastUpdated.getTime());
    } else {
      this.initialUpdateTime = this.interval;
    }

    this.localStorage.clear('lastUpdated');
    this.router = router;
    this.marketList = this.router.url;
    this.jhiLanguageService.setLocations(['markets']);
    const today = new Date();

    this.keys(MarketdateStatusEnum).forEach((value, index) => {
      if (!this.marketdateStatus) {
        this.marketdateStatus = [];
      }
      this.marketdateStatus.push({
        value: value,
        label: value,
        selected: this.getMarketDateStatus(value, 'selected'),
        visible: this.getMarketDateStatus(value, 'visible')
      });
    });

    const currentDate =  new Date(today.getFullYear(), today.getMonth(), today.getDate());
    let beginDate = currentDate;
    let endDate = currentDate;

    if (this.router.url === '/planning') {
      beginDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - 365);
      endDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() + 7);
      // this.dateRangePickerOptions.disableUntil = {
      //   year: currentDate.getFullYear(),
      //   month: currentDate.getMonth() + 1,
      //   day: currentDate.getDate() - 1
      // };
      this.sorting = [{prop: 'evasiveDate', dir: 'asc'}];
    } else if (this.router.url === '/open-accountings') {
      beginDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - 365);
      endDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
      // this.dateRangePickerOptions.disableSince = {
      //   year: currentDate.getFullYear(),
      //   month: currentDate.getMonth() + 1,
      //   day: currentDate.getDate() + 1
      // };
      this.sorting = [{prop: 'status', dir: 'asc'}, {prop: 'evasiveDate', dir: 'asc'}];
    } else if (this.router.url === '/archive') {
      beginDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - 62);
      endDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
      // this.dateRangePickerOptions.disableSince = {
      //   year: currentDate.getFullYear(),
      //   month: currentDate.getMonth() + 1,
      //   day: currentDate.getDate() + 1
      // };
      this.sorting = [{prop: 'evasiveDate', dir: 'desc'}];
    };

    this.dateRangeModel = {
      beginDate: {
        year: beginDate.getFullYear(),
        month: beginDate.getMonth() + 1,
        day: beginDate.getDate()
      },
      endDate: {
        year: endDate.getFullYear(),
        month: endDate.getMonth() + 1,
        day: endDate.getDate()
      }
    };

    this.maxDateRangeDays = Math.round((endDate.getTime() - beginDate.getTime()) / (1000 * 60 * 60 * 24));
    if (this.router.url === '/archive') {
      const beginDateArchive = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - 365);
      this.maxDateRangeDays = Math.round((endDate.getTime() - beginDateArchive.getTime()) / (1000 * 60 * 60 * 24));
    }

    this.daterangeFilter = {
      label: 'Zeitraum',
      options: [
        {
          value: 'all',
          label: 'alle Märkte',
          selected: true
        },
        {
          value: 'future',
          label: 'zukünftige Märkte (einschließlich heute)'
          ,
          selected: false
        },
        {
          value: 'past',
          label: 'vergangene Märkte',
          selected: false
        }
      ],
      selected: {
        value: 'all',
        label: 'alle Märkte',
        selected: true
      }
    };
  }

  @HostListener('window:resize', ['$event']) onResize(event) {
    this.recalculateTable();
  }

  sortClick(event: any) {
    if (this.sortType === 'multi') {
      this.sortType = 'single';
      this.sorting = [{prop: event.column.prop, dir: event.newValue}];
    }
    this.routingData.setLastMarketListSort({type: 'single', prop: event.column.prop, dir: event.newValue});
  }

  getMarketDateStatus(marketdateStatus, type: 'selected' | 'visible') {
    let result = false;
    switch (this.router.url) {
      case '/planning':
        if (type === 'selected') {
          if (marketdateStatus === MarketdateStatusEnum.Unopened.toString()) {
            result = true;
          }
        } else if (type === 'visible') {
          result = false;
        }
        break;
      case '/open-accountings':
        if (type === 'selected') {
          if (marketdateStatus === MarketdateStatusEnum.Opened.toString() ||
            marketdateStatus === MarketdateStatusEnum.Closed.toString()) {
            result = true;
          }
        } else if (type === 'visible') {
          if (marketdateStatus === MarketdateStatusEnum.Opened.toString() ||
            marketdateStatus === MarketdateStatusEnum.Closed.toString()) {
            result = true;
          }
        }
        break;
      case '/archive':
        if (type === 'selected') {
          if (marketdateStatus === MarketdateStatusEnum.Confirmed.toString() ||
            marketdateStatus === MarketdateStatusEnum.Canceled.toString() ||
            marketdateStatus === MarketdateStatusEnum.CanceledWeather.toString() ||
            marketdateStatus === MarketdateStatusEnum.CanceledOtherEvent.toString() ||
            marketdateStatus === MarketdateStatusEnum.Manual.toString()) {
            result = true;
          }
        } else if (type === 'visible') {
          result = false;
        }
        break;
      default:
        break;
    }
    return result;
  }

  setDataTableColumnModeToForce() {
    if (this.marketsTable) {
      this.marketsTable.columnMode = ColumnMode.force;
    } else {
      setTimeout(() => {
        this.setDataTableColumnModeToForce();
      }, 100);
    }
  }

  changeDaterangeFilter(daterangeFilterOption) {
    this.searchInputMarketTitle = '';
    this.searchInputMarketMaster = '';
    this.branchFilter.selected = this.branchFilter.options.find(option => option.value === 'all');
    this.routingData.selectedBranchFilter = this.branchFilter.selected;
    this.daterangeFilter.options.map(option => (option.value !== daterangeFilterOption.value) ?
      option.selected = false : option.selected = true);
    this.daterangeFilter.selected = daterangeFilterOption;
    const today = new Date();
    const currentDate =  new Date(today.getFullYear(), today.getMonth(), today.getDate());
    let beginDate = currentDate;
    let endDate = currentDate;

    switch (daterangeFilterOption.value) {
      case 'future':
        beginDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
        endDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() + 7);
        break;
      case 'past':
        beginDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - 365);
        endDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - 1);
        break;
      default:
      case 'all':
        beginDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - 365);
        endDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() + 7);
        break;
    }

    this.dateRangeModel = {
      beginDate: {
        year: beginDate.getFullYear(),
        month: beginDate.getMonth() + 1,
        day: beginDate.getDate()
      },
      endDate: {
        year: endDate.getFullYear(),
        month: endDate.getMonth() + 1,
        day: endDate.getDate()
      }
    };
    this.dateRangeChanged = true;
    this.getMarketOverviewEntries(false);
  }

  getActiveMarketdateStates() {
    const result = [];
    this.marketdateStatus.forEach(marketdateStatus => {
      if (marketdateStatus.selected) {
        result.push(marketdateStatus.value);
      }
    });
    return result;
  }

  async updateMarketsFilter() {
    let filteredMarkets = [];

    this.marketdateStatus.forEach(status => {
      if (status.selected) {
        const temp = this.marketOverviewEntries.filter(function (marketOverviewEntry) {
          return marketOverviewEntry.status.toLowerCase() === status.value.toLowerCase();
        });
        temp.forEach(value => {
          value['dayOfWeek'] = this.datePipe.transform(value.evasiveDate, 'EEEE');

          value['closingMmDisplayName'] = (value && value.closedBy) ?
            value.closedBy : '---';

          value['mm1DisplayName'] = (value && value.mm1DisplayName) ?
            value.mm1DisplayName : '---';
          value['mm1Phone'] = (value && value.mm1Phone) ?
            value.mm1Phone : '---';
          value['mm1Mobile'] = (value && value.mm1Mobile) ?
            value.mm1Mobile : '---';
          value['mm1Number'] = (value && value.mm1Number) ?
            value.mm1Number : '---';

          value['mm2DisplayName'] = (value && value.mm2DisplayName) ?
            value.mm2DisplayName : '---';
          value['mm2Phone'] = (value && value.mm2Phone) ?
            value.mm2Phone : '---';
          value['mm2Mobile'] = (value && value.mm2Mobile) ?
            value.mm2Mobile : '---';
          value['mm2Number'] = (value && value.mm2Number) ?
            value.mm2Number : '---';

          value['info'] = '';
          if (value.openPayments) {
            value['info'] = 'Offene Restbeträge';
          }
          if (value.discounts) {
            value['info'] = (value.openPayments) ? [value['info'], 'Rabatte'].join(', ') : 'Rabatte';
          }

          filteredMarkets.push(value);
        });
      }
    });

    this.user = await this.principal.identity();

    if (this.user
      && this.user.contact.branchString !== '01 - Geschäftsführung'
      && this.user.contact.branchString !== '09 - allg. Verwaltung') {
      filteredMarkets = filteredMarkets.filter(item => this.user.contact.branches.indexOf(item.branch) !== -1);
    }

    this.allRows = [...filteredMarkets];
    this.tempRows = [...filteredMarkets];
    this.rows = filteredMarkets;
    if (this.marketsTable) {
      this.marketsTable.offset = 0;
    }

    await this.fillBranchFilterOptions();
    this.branchFilter.selected = this.routingData.selectedBranchFilter;

    if (this.router.url === '/archive' || this.router.url === '/open-accountings') {
      this.filterMarkets();
    }

  }

  ngOnInit() {

    this.statusFilter = {
      filterProperty: 'status',
      label: 'Status',
      options: [
        {
          value: 'all',
          label: 'alle'
        }
      ],
      selected: {
        value: 'all',
        label: 'alle'
      }
    };

    if (!this.routingData.selectedStatusFilter) {
      this.routingData.selectedStatusFilter = this.statusFilter.selected;
    }

    this.weekdayFilter = {
      filterProperty: 'dayOfWeek',
      label: 'Wochentag',
      options: [
        {
          value: 'all',
          label: 'alle'
        }
      ],
      selected: {
        value: 'all',
        label: 'alle'
      }
    };

    if (!this.routingData.selectedWeekdayFilter) {
      this.routingData.selectedWeekdayFilter = this.weekdayFilter.selected;
    }

    this.branchFilter = {
      filterProperty: 'branch',
      label: 'Niederlassung',
      options: [
        {
          value: 'all',
          label: 'alle Niederlassungen'
        }
      ],
      selected: {
        value: 'all',
        label: 'alle Niederlassungen'
      }
    };
    if (this.routingData.selectedBranchFilter) {
      this.branchFilter.selected = this.routingData.selectedBranchFilter;
    }

    if (!this.routingData.selectedBranchFilter) {
      this.routingData.selectedBranchFilter = this.branchFilter.selected;
    }

    this.fillStatusFilterOptions();
    this.fillWeekdayFilterOptions();

    const lastMarketList = this.routingData.getLastMarketList();
    const lastMarketListPage = this.routingData.getLastMarketListPage();
    const lastMarketListSort = this.routingData.getLastMarketListSort();
    this.searchInputMarketTitle = this.routingData.searchValMarketTitle;
    this.searchInputMarketNumber = this.routingData.searchValMarketNumber;
    this.searchInputMarketMaster = this.routingData.searchValMarketMaster;
    this.searchInputClosingMarketMaster = this.routingData.searchValClosingMarketMaster;

    this.statusFilter.selected = this.routingData.selectedStatusFilter;
    this.weekdayFilter.selected = this.routingData.selectedWeekdayFilter;

    if (lastMarketList === this.router.url && this.routingData.getMarketOverviewEntries()) {
      this.marketOverviewEntries = this.routingData.getMarketOverviewEntries();
      this.offset = (lastMarketListPage && lastMarketListPage.offset) ? lastMarketListPage.offset : 0;

      if (lastMarketListSort && lastMarketListSort.hasOwnProperty('type')
        && (lastMarketListSort.type === 'multi' || lastMarketListSort.type === 'single')) {
        this.sortType = lastMarketListSort.type;
      }
      if (lastMarketListSort && lastMarketListSort.hasOwnProperty('prop') && lastMarketListSort.hasOwnProperty('dir')) {
        this.sorting = [{prop: lastMarketListSort.prop, dir: lastMarketListSort.dir}];
      }

    } else if (lastMarketList !== this.router.url && this.routingData.getMarketOverviewEntries()) {
      this.marketOverviewEntries = [];
      this.routingData.clearMarketOverviewEntries();
      this.routingData.clearSearchQueryValues();
      this.routingData.clearSelectedFilters();
      this.routingData.setLastMarketListPage(null);
      this.routingData.setLastMarketListSort(null);
    } else {
      this.marketOverviewEntries = [];
      this.routingData.setLastMarketListPage(null);
      this.routingData.setLastMarketListSort(null);
    }
    this.getMarketOverviewEntries(this.marketOverviewEntries.length !== 0);
    if (this.router.url !== '/archive') {
      TimerObservable.create(this.initialUpdateTime, this.interval)
        .takeWhile(() => this.alive)
        .subscribe(() => {
          const currentDate = new Date();
          console.log('[Timed Event: ' +
            ('0' + currentDate.getHours()).slice(-2) + ':' +
            ('0' + currentDate.getMinutes()).slice(-2) + ':' +
            ('0' + currentDate.getSeconds()).slice(-2) + '] - Autoupdate: ', this.autoUpdateActive);

          if (this.autoUpdateActive && !this.loadingIndicator) {
            this.refreshModalRef = this.modalService.open(this.refreshModal);
            this.getMarketOverviewEntries(false);
          }
        });
    }

    this.eventManager.subscribe('toggleSidebar', (message) => {
      this.recalculateTable();
    });
    setTimeout(() => this.recalculateTable(), 300);



  }

  recalculateTable() {
    this.calculateTableRows();
    setTimeout(() => {
      if (this.marketsTable) {
        this.marketsTable.recalculate();
        this.marketsTable.offset = 0;
      }
    }, 300);
  }

  calculateTableRows() {
    const windowHeight = window.innerHeight;
    const marketHeader = document.getElementById('markets-header');
    const marketInfo = document.getElementById('markets-information');
    const appHeaderHeight = 50;
    const marketsHeaderHeight = marketHeader ? marketHeader.offsetHeight : 45;
    const marketsInformationHeight = marketInfo ?  marketInfo.offsetHeight : 45;
    const tableHeaderHeight = 45;
    const tableFooterHeight = 50;
    const appFooter = 50;
    const paddings = 20;

    const tableHeight = windowHeight - appHeaderHeight - marketsHeaderHeight - marketsInformationHeight
      - tableHeaderHeight - tableFooterHeight - appFooter - paddings;

    const possibleRowCount = Math.floor(tableHeight / 40);
    if (possibleRowCount) {
      this.limit = (possibleRowCount > 0) ? possibleRowCount : 1;
    }
  }

  autoUpdateChange() {
    this.localStorage.store('autoUpdate', this.autoUpdateActive);
  }

  ngOnDestroy() {
    this.alive = false;
    // his.branchFilter.selected = this.branchFilter.options.find(o => o.value === 'all');
    this.routingData.selectedBranchFilter = this.branchFilter.selected;
  }

  onInputFieldChanged(event) {
    this.dateRangeIsValid = event.valid;
  }

  keys(obj): Array<string> {
    return Object.keys(obj);
  }

  onDateRangeChanged(event: IMyDateRangeModel) {
    const selectedBeginDate = event.beginJsDate;
    const selectedEndDate = event.endJsDate;
    if (selectedBeginDate != null && selectedEndDate != null) {
      const timeDiff = Math.abs(selectedEndDate.getTime() - selectedBeginDate.getTime());
      const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
      if (diffDays > this.maxDateRangeDays) {
        this.openDateRangeToLargeModal(event);
      } else {
        this.dateRangeChanged = true;
      }
    }
  }

  openDateRangeToLargeModal(dateRangeChangedEvent) {
    const beginDate = new Date(dateRangeChangedEvent.beginJsDate.getFullYear(),
      dateRangeChangedEvent.beginJsDate.getMonth() + 1,
      dateRangeChangedEvent.beginJsDate.getDate());
    const newEndDate = new Date(new Date(beginDate).setDate(new Date(beginDate).getDate() + this.maxDateRangeDays));
    this.newEndDate = new Date(new Date(newEndDate).setMonth(new Date(newEndDate).getMonth() - 1));
    this.dateRangeToLargeModalReg = this.modalService.open(this.dateRangeToLargeModal);
    this.dateRangeToLargeModalReg.result.then(close => {
      this.setNewDateRange(beginDate, newEndDate);
      this.dateRangeToLargeModalReg.close();
    }, dismiss => {
      this.setNewDateRange(beginDate, newEndDate);
      this.dateRangeToLargeModalReg.close();
    });
  }

  setNewDateRange(beginDate, endDate) {
    this.dateRangeModel = {
      beginDate: {
        year: beginDate.getFullYear(),
        month: beginDate.getMonth(),
        day: beginDate.getDate()
      },
      endDate: {
        year: endDate.getFullYear(),
        month: endDate.getMonth(),
        day: endDate.getDate()
      }
    };
    this.dateRangeChanged = true;
  }

  getMarketOverviewEntries(fromLocalStorage: boolean) {
    this.loadingIndicator = true;
    const beginDate = new Date(this.dateRangeModel.beginDate.year,
      this.dateRangeModel.beginDate.month - 1,
      this.dateRangeModel.beginDate.day);
    const beginDateString = beginDate.getFullYear() + '-' +
      ('0' + (beginDate.getMonth() + 1)).slice(-2) + '-' +
      ('0' + beginDate.getDate()).slice(-2);

    const endDate = new Date(this.dateRangeModel.endDate.year,
      this.dateRangeModel.endDate.month - 1,
      this.dateRangeModel.endDate.day);
    const endDateString = endDate.getFullYear() + '-' +
      ('0' + (endDate.getMonth() + 1)).slice(-2) + '-' +
      ('0' + endDate.getDate()).slice(-2);

    // const marketViewEntryApiUrl = 'backoffice/overview/' + beginDateString + '/' + endDateString;
    const marketViewEntryApiUrl = 'backoffice/overview-by-status/' + beginDateString + '/' + endDateString;
    const states = this.getActiveMarketdateStates();

    if (fromLocalStorage) {
      this.marketOverviewEntries = this.routingData.getMarketOverviewEntries();
      this.routingData.clearMarketOverviewEntries();
      this.dateRangeChanged = false;
      this.loadingIndicator = false;
      this.setDataTableColumnModeToForce();
      this.updateMarketsFilter();
      if (this.refreshModalRef) {
        this.refreshModalRef.close();
      }
    } else {
      this.apiService.getMarkets<MarketOverviewViewEntry>(MarketOverviewViewEntry, marketViewEntryApiUrl, states)
        .subscribe(marketOverviewEntries => {
          this.marketOverviewEntries = marketOverviewEntries;
          this.dateRangeChanged = false;
          this.loadingIndicator = false;
          this.setDataTableColumnModeToForce();
          this.lastUpdated = new Date();
          this.updateMarketsFilter();
          if (this.refreshModalRef) {
            this.refreshModalRef.close();
          }
          }, error => {
          this.marketOverviewEntries = [];
          this.dateRangeChanged = false;
          this.loadingIndicator = false;
          this.setDataTableColumnModeToForce();
          this.lastUpdated = new Date();
          this.updateMarketsFilter();
          if (this.refreshModalRef) {
            this.refreshModalRef.close();
          }
          this.loadingError = error;
          this.modalService.open(this.errorLoadingMarketsModal);
        });
    }

    this.updateSearch(null);
  }

  fillStatusFilterOptions() {
    this.statusFilter.options = [{value: 'all', label: 'alle'}];
    const statuses = [
      'CanceledOtherEvent',
      'CanceledWeather',
      'Confirmed',
      'Canceled',
      'Manual'
    ]
      .forEach(status => {
        if (status && status !== '') {
          this.statusFilter.options.push({
            value: status,
            label: status
          });
        }
      });
  }

  fillWeekdayFilterOptions() {
    this.weekdayFilter.options = [{value: 'all', label: 'alle'}];
    const weekdays = ['Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag', 'Sonntag']
      .forEach(status => {
        if (status && status !== '') {
          this.weekdayFilter.options.push({
            value: status,
            label: status
          });
        }
      });
  }

  async fillBranchFilterOptions() {
    this.branchFilter.options = [
      {
        value: 'all',
        label: 'alle Niederlassungen'
      }
    ];
    const branches = await this.apiService.getBranches();
    branches.forEach(branch => {
      if (branch.branchNumber !== 10 && branch.branchNumber !== 11) {
        this.branchFilter.options.push({
          value: branch.name,
          label: branch.name
        });
      }
    });
  }

  rowClass = (row) => {
    let warningEvasive: boolean, warningUnopened: boolean;
    switch (this.marketList) {
      case '/planning':
        warningEvasive = (row.evasiveDate !== row.originalDate);
        warningEvasive = false; // no more line highlighting
        const oDate = new Date(row.originalDate);
        const cDate = new Date(new Date().setHours(0, 0, 0, 0));
        warningUnopened = (oDate < cDate);
        break;
      case '/open-accountings':
      case '/archive':
      default:
        break;
    }

    return {
      'marketdate-warning-evasive': warningEvasive,
      'marketdate-warning-unopened': warningUnopened
    };
  }

  onSelect(event) {
    this.routingData.setLastMarketList(this.router.url);
    this.localStorage.store('lastUpdated', this.lastUpdated);
    this.routingData.setMarketOverviewEntries(this.marketOverviewEntries);
    this.router.navigate([this.router.url + '/' + event.selected[0].marketdateId]);
  }

  openModal(modal: any, contact: MarketAccounting) {
    this.modalRef = this.modalService.open(modal);
    this.selectedMarketAccounting = contact;
  }

  deleteContact() {
    if (this.selectedMarketAccounting) {
      this.modalRef.close();
    }
  }

  changeFilter(filter, filterOption) {
    filter.selected = filterOption;

    if (filter === this.statusFilter) {
      this.routingData.selectedStatusFilter = this.statusFilter.selected;
    }

    if (filter === this.weekdayFilter) {
      this.routingData.selectedWeekdayFilter = this.weekdayFilter.selected;
    }

    if (filter === this.branchFilter) {
      this.routingData.selectedBranchFilter = this.branchFilter.selected;
    }

    this.filterMarkets();
  }

  filterMarkets() {
    const filterItems = [
      this.statusFilter,
      this.weekdayFilter,
      this.branchFilter
    ].filter(filterItem => filterItem && filterItem.selected && filterItem.selected.value !== 'all');

    this.rows = this.allRows.filter(item => {
      for (let i = 0; i < filterItems.length; i++) {
        if (item[filterItems[i].filterProperty] !== filterItems[i].selected.value) {
          return false;
        }
      }
      return true;
    });

    // if (this.statusFilter.selected.value !== 'all' && this.weekdayFilter.selected.value !== 'all') {
    //   this.rows = this.allRows
    //     .filter(item => item.status === this.statusFilter.selected.value
    //       && item.dayOfWeek === this.weekdayFilter.selected.value);
    // } else if (this.statusFilter.selected.value !== 'all' && this.weekdayFilter.selected.value === 'all') {
    //   this.rows = this.allRows
    //     .filter(item => item.status === this.statusFilter.selected.value);
    // } else if (this.statusFilter.selected.value === 'all' && this.weekdayFilter.selected.value !== 'all') {
    //   this.rows = this.allRows
    //     .filter(item => item.dayOfWeek === this.weekdayFilter.selected.value);
    // } else {
    //   this.rows = this.allRows;
    // }

    this.tempRows = [...this.rows];

    if (this.searchInputMarketTitle !== '' || this.searchInputMarketNumber !== '') {
      this.updateSearch(null);
    } else {
      setTimeout(() => {
        if (this.marketsTable) {
          this.marketsTable.offset = 0;
        }
      }, 300);
    }
  }

  marketsTablePage(event) {
    this.routingData.setLastMarketListPage(event);
  }

  updateSearch(event) {
    const searchValMarketTitle = this.searchInputMarketTitle.toLowerCase();
    this.routingData.searchValMarketTitle = searchValMarketTitle;
    const searchValMarketNumber = this.searchInputMarketNumber.toLowerCase();
    this.routingData.searchValMarketNumber = searchValMarketNumber;
    const searchValMarketMaster = this.searchInputMarketMaster.toLowerCase();
    this.routingData.searchValMarketMaster = searchValMarketMaster;
    const searchValClosingMarketMaster = this.searchInputClosingMarketMaster.toLowerCase();
    this.routingData.searchValClosingMarketMaster = searchValClosingMarketMaster;

    const temp = this.tempRows.filter(d => {
      return (d.marketTitle.toLowerCase().indexOf(searchValMarketTitle) !== -1 || !searchValMarketTitle) &&
        (d.mm1DisplayName.toLowerCase().indexOf(searchValMarketMaster) !== -1 || !searchValMarketMaster) &&
        ((d.closedBy != null && d.closedBy.toLowerCase().indexOf(searchValClosingMarketMaster) !== -1) || !searchValClosingMarketMaster) &&
        (d.marketdayNumber.toLowerCase().indexOf(searchValMarketNumber) !== -1 || !searchValMarketNumber)
        ;
    });

    this.rows = temp;
    setTimeout(() => {
      if (this.marketsTable) {
        this.marketsTable.offset = 0;
      }
    }, 300);
  }

  openedMarketdateInPast(row): boolean {
    const rowDate = new Date(row.evasiveDate);
    const nowDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0 , 0);
    return (row.status === 'Opened' && rowDate < nowDate);
  }

}



// WEBPACK FOOTER //
// ./src/app/markets/components/markets/markets.component.ts